import { Link } from 'react-router-dom';

export default function ContactHero() {
  return (
    <section
      className="relative w-full min-h-screen flex items-center overflow-hidden"
      style={{
        backgroundImage:
          'url(https://public.readdy.ai/ai/img_res/1deafe9b8c0be0579016d802cf27a2f7.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center 40%',
      }}
    >
      {/* Overlays */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A]/97 via-[#0A0A0A]/85 to-[#0A0A0A]/40" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/55 via-transparent to-[#0A0A0A]/70" />

      {/* Gold vertical accent */}
      <div className="absolute left-0 top-0 h-full w-0.5 bg-gradient-to-b from-transparent via-[#C9A030]/40 to-transparent hidden lg:block" />

      {/* Breadcrumb */}
      <div className="absolute top-0 left-0 w-full pt-24 px-6 lg:px-14 z-10">
        <p className="text-[#C9A030] text-[10px] tracking-[0.4em] uppercase font-semibold flex items-center gap-3">
          <Link to="/" className="hover:text-[#D4B045] cursor-pointer transition-colors">Home</Link>
          <span className="text-[#F2EDE3]/20">/</span>
          <span className="text-[#F2EDE3]/50">Contact</span>
        </p>
      </div>

      {/* Main content */}
      <div className="relative z-10 w-full px-6 lg:px-14 pb-20">
        <div className="max-w-[680px]">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-10 h-px bg-[#C9A030]" />
            <p className="text-[#C9A030] text-[10px] tracking-[0.45em] uppercase font-semibold">
              Get Started Today
            </p>
          </div>

          <h1 className="font-serif leading-[1.05] tracking-tight mb-8">
            <span className="block text-[46px] lg:text-[76px] font-light text-[#F2EDE3]">
              Let&rsquo;s Get Your
            </span>
            <span className="block text-[46px] lg:text-[76px] font-light text-[#F2EDE3]">
              Compliance
            </span>
            <span className="block text-[46px] lg:text-[76px] font-light text-[#C9A030] italic">
              Handled.
            </span>
          </h1>

          <p className="text-[#F2EDE3]/50 text-lg font-light leading-relaxed mb-9 max-w-[500px]">
            Call or fill out the form below. A dedicated ECS expert will respond within one business day — often the same day.
          </p>

          {/* Prominent phone CTA */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <a
              href="tel:4054081117"
              className="inline-flex items-center gap-3 bg-[#C9A030] text-[#0A0A0A] px-9 py-4 text-[11px] font-bold tracking-[0.22em] uppercase whitespace-nowrap cursor-pointer transition-colors duration-200 hover:bg-[#D4B045] w-fit"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-sm" />
              </span>
              Call 405-408-1117 Now
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 border border-[#F2EDE3]/22 text-[#F2EDE3]/70 px-8 py-4 text-[11px] font-medium tracking-[0.22em] uppercase whitespace-nowrap cursor-pointer transition-colors duration-200 hover:border-[#C9A030]/60 hover:text-[#C9A030] w-fit"
            >
              Send a Message
            </Link>
          </div>

          {/* Quick trust signals */}
          <div className="flex flex-wrap items-center gap-x-8 gap-y-3">
            {[
              { icon: 'ri-time-line', text: 'Response within 1 business day' },
              { icon: 'ri-shield-check-fill', text: '100% Approval Guaranteed' },
              { icon: 'ri-calendar-check-line', text: 'No Contracts Required' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${item.icon} text-[#C9A030] text-sm`} />
                </div>
                <span className="text-[#F2EDE3]/40 text-[11px] tracking-[0.18em] uppercase font-light whitespace-nowrap">
                  {item.text}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Floating contact card — right side */}
      <div className="absolute bottom-10 right-12 hidden xl:block">
        <div className="bg-[#0A0A0A]/80 border border-[#C9A030]/18 backdrop-blur-sm px-7 py-6 max-w-[240px]">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-8 bg-[#C9A030] flex items-center justify-center">
              <i className="ri-phone-fill text-[#0A0A0A] text-base" />
            </div>
            <div>
              <p className="text-[#F2EDE3]/40 text-[9px] tracking-[0.25em] uppercase font-medium">Direct Line</p>
              <a href="tel:4054081117" className="text-[#C9A030] font-semibold text-base cursor-pointer hover:text-[#D4B045] transition-colors">
                405-408-1117
              </a>
            </div>
          </div>
          <div className="w-full h-px bg-[#C9A030]/15 mb-4" />
          <p className="text-[#9A9A9A] text-xs font-light leading-relaxed">
            Your dedicated ECS expert is one call away — same person, every time.
          </p>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 left-14 hidden lg:flex flex-col items-center gap-3 text-[#F2EDE3]/20">
        <div className="w-px h-14 bg-gradient-to-b from-[#C9A030]/50 to-transparent" />
        <span className="text-[9px] tracking-[0.4em] uppercase font-light">Scroll</span>
      </div>
    </section>
  );
}
